<template>
    <h1 v-if="!pokemon">Espere por favor...</h1>

    <div class="game-box" v-else>
        <div class="title">¿Quién es este pokémon?</div>
        <!--TODO: IMG   los : solo no es necesario v-bind-->
        <PokemonPicture
            :pokemonId="pokemon.id"
            :showPokemon="showPokemon"/>
        <!--TODO: OPCIONES-->
        <PokemonOptions
            :pokemons="pokemonArr"
            @selection="checkAnswer"    
        />
        <template visibility="hidden" v-if="showAnswer">
            <div class="message fade-in">{{message}}</div>
            <div class="no-lifes">{{lastLife}}</div>
            <div class="no-points">{{lastPoints}}</div>
            <button  class="button btn btn-success" @click="newGame">
            {{button}}
            </button>
        </template>
        <PokemonLifes
            :lifes="lifes"
        />
        <div class="points">
            Puntos: <br>{{ points }}
        </div>
        
    </div>

</template>



<script>
import PokemonPicture from '@/components/PokemonPicture.vue';
import PokemonOptions from '@/components/PokemonOptions.vue';
import PokemonLifes from '@/components/PokemonLifes.vue';


import getPokemonOptions from '@/helpers/getPokemonOptions'



export default {
    name: 'PokemonPage',
    components: {
        PokemonPicture,
        PokemonOptions,
        PokemonLifes
    },
    data() {
        return {
            pokemonArr: [],
            pokemon: null,
            showPokemon: false,
            showAnswer: false,
            message: '',
            lifes: 3,
            button: '',
            points: 0,
            lastLife: '',
            lastPoints: ''
        }
    },
    methods: {
        async mixPokemonArray(){
            this.pokemonArr = await getPokemonOptions()
            

            const rndInt = Math.floor( Math.random() * 4 )
            this.pokemon = this.pokemonArr[rndInt]
        },
        checkAnswer(selectedId){
            this.showPokemon = true
            this.showAnswer = true
            if (this.pokemon.id == selectedId && this.lifes >= 1){
                this.message = 'CORRECTO'
                this.button = 'SIGUIENTE'
                this.points += 10
            } else {
                this.lifes = this.lifes - 1
                if (this.lifes >= 1){
                    this.message = `Ohh... era ${this.pokemon.name}`
                    this.button = 'SIGUIENTE'
                } else{

                    this.message = `Ohh... era ${this.pokemon.name}`
                    this.lastLife = `Te has quedado sin vidas \r\n`
                    this.lastPoints = `PUNTOS: ${this.points}`
                    this.button = 'NUEVO JUEGO'
                }
            }
        }
            ,
        newGame(){

            if(this.button == 'NUEVO JUEGO'){
                this.showAnswer = false
                this.showPokemon = false
                this.pokemonArr = []
                this.pokemon = null
                this.mixPokemonArray()
                this.lifes = 3
                this.points = 0
                this.lastLife = ''
                this.lastPoints = ''
            } else {
                this.showAnswer = false
                this.showPokemon = false
                this.pokemonArr = []
                this.pokemon = null
                this.mixPokemonArray()
            }
            
        }
    },
    mounted(){
        this.mixPokemonArray('')
    }
}
</script>



<style scoped>
.game-box{
    background-color: rgb(212, 212, 212);
    width: 550px;
    height: 700px;
    margin: auto;
    padding-top: 5px;
    position: relative;
    border-radius: 5%;
    .title{
        font-size: xx-large;
        margin-left: 10px;
        margin-right: 10px;
        padding: 10px;
    }
    .no-lifes, .no-points{
        font-size: larger;
    }
    .message{
        font-size: larger;
        margin: 20px;
    }
}

.button{
    background-color: rgb(34, 34, 34);
    color: rgb(230, 230, 230);
    margin: 10px;
    font-size: large;
}

.lifes{
    position: absolute;
    margin: 20px;
    bottom:0;
    left:0;
}

.points{
    background-color: rgb(167, 167, 167);
    border-radius: 10%;
    font-size: 25px;
    font-weight: bold;
    position: absolute;
    margin-right: 20px;
    margin-bottom: 20px;
    bottom:0;
    right:0;
    padding: 10px;
}

</style>